module.exports = __webpack_public_path__ + "static/media/语音听写.78f797db.png";